import React from 'react';
import classes from './Process.module.css';
import {Typography , Box} from '@mui/material';
import TextContent from '../../UI/TextContent';
import Grid from '@mui/material/Unstable_Grid2';

import conference from '../../../assets/img/confer.png';

const process_data = [
    {
        title: "1단계",
        description: ['평가대상 공정선정'],
        color: "red"
    },
    {
        title: "2단계",
        description: ['위험요인 도출'],
        color: "blue"
    },
    {
        title: "3단계",
        description: ['위험도 계산'],
        color: "red"
    },
    {
        title: "4단계",
        description: ['위험도 평가'],
        color: "red"
    },
    {
        title: "5단계",
        description: ['개선대책 수립'],
        color: "red"
    }
]



const Step = props => {
    return (
        <div>
            <div className={classes.steparea}>
                <div className={classes.stepItem}>
                    <div className={classes.number}>
                    </div>
                </div>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <Typography variant="contentTitle" marginBottom="0" paddingLeft="10px">{props.title}</Typography>
                    <Typography variant="description" component="span" marginLeft="1rem">{props.description}</Typography>
                </div>
            </div>
            <div className={classes.stepContent}>
                
            </div>
        </div>
    )
}

const Process = props => {
    return (
        <TextContent maxWidth="md" sectionStyle={props.style}>
            <Grid 
                container 
                justifyContent={'space-between'} 
                alignItems={'center'}
                width="100%"
            >
                <Grid 
                    xs={12} 
                    sm={6} 
                    md={6} 
                    padding={5}
                >
                    <Typography 
                        variant="subTitle" 
                        component="h2" 
                        sx={{marginBottom: '50px'}}
                    >
                        위험성 평가
                    </Typography>

                    <Box>
                        {process_data.map( (process, index) => (
                            <Step 
                                key={index} 
                                title={process.title} 
                                description={process.description}
                            />
                        ))}
                    </Box>
                </Grid>

                <Grid 
                    xs={12} 
                    sm={6} 
                    md={5}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <img src={conference} alt="conference" style={{ width:'100%'}}/>
                </Grid>

            </Grid>
        </TextContent>
    )
}

export default Process;